import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { Icon, Tooltip } from '@common/ui/general';

function BadgedPerformance({
  title, icon, stat, suffix, border, className, tooltip,
}) {
  return (
    <div
      className={classNames(
        'badged-performance',
        {
          'badged-performance--bordered': border,
        },
      )}
    >
      <Tooltip
        className={classNames(
          'badged-performance__title row align-c',
          { [className]: className },
        )}
        isDisabled={!tooltip}
        title={tooltip || ''}
      >
        {title}
        {!!tooltip && <Icon className="m-l-5" name="info" />}
      </Tooltip>
      <div className="badged-performance__container">
        <img src={icon} alt={title} className="badged-performance__icon" />
        <div className="badged-performance__stat">
          {stat}
        </div>
      </div>
      <div className="badged-performance__suffix">
        {suffix}
      </div>
    </div>
  );
}

BadgedPerformance.propTypes = {
  title: propTypes.string,
  icon: propTypes.string,
  stat: propTypes.oneOfType([propTypes.string, propTypes.number]),
  suffix: propTypes.string,
  border: propTypes.bool,
};

export default BadgedPerformance;
